import type { Direction } from "../lib/scoring";
import snapshot from "./generated/site-content.json" with { type: "json" };
import {
  offerCopySchema,
  offersSchema,
  type DirectionOffer,
  type Offer,
} from "./schemas";

/**
 * Which direction an offer belongs to is the one thing that is not editorial:
 * it is wired to `computeDirection`, so the Soul Check result and the board it
 * highlights must keep pointing at the same offer. Everything else — wording,
 * price and payment link — is authored in Sanity.
 */
const offerDirections = [
  "special",
  "heart-to-heart",
  "the-wave",
  null,
] as const;

const offerCopy = offerCopySchema.parse(snapshot.offers);

// Both are fixed four-item tuples in the same order, so the merge is positional
// and `offersSchema` re-checks that each id kept its own direction.
export const offers = offersSchema.parse(
  offerCopy.map((copy, index) => ({
    ...copy,
    direction: offerDirections[index],
  })),
);

export const offerByDirection: Readonly<Record<Direction, DirectionOffer>> = {
  special: offers[0],
  "heart-to-heart": offers[1],
  "the-wave": offers[2],
};

export const substackOffer: Offer = offers[3];
